import { Component } from '@angular/core';

@Component({
  selector: 'app-login-failed',
  imports: [],
  templateUrl: './login-failed.component.html',
  styleUrl: './login-failed.component.scss',
})
export class LoginFailedComponent {}
